import { combineReducers, Reducer } from "@reduxjs/toolkit";
/* Instruments */
import { userSlice } from "./slices";

const combine = combineReducers({
  user: userSlice.reducer
});

type ReduxState = ReturnType<typeof combine>;

export const reducer: Reducer<ReduxState> = (state, action) => {
  if (action.type === "resetState") {
    return combine(undefined, action);
  }
  return combine(state, action);
};
